import type { EventSegmentType } from '@eti/schema-types';
import type { BoundsType } from '../models';

export const getUniqueTripEventTypes = (bounds: BoundsType): EventSegmentType[] => {
  return Array.from(
    new Set(
      bounds
        ? bounds.flatMap((bound) =>
            bound
              ? bound.segments.flatMap((segment) => {
                  if (segment && segment.__typename === 'EventSegment') {
                    const { types } = segment;
                    if (types) {
                      return types.filter((t): t is Exclude<typeof t, null> => t !== null);
                    }
                    return [];
                  }
                  return [];
                })
              : [],
          )
        : [],
    ),
  );
};
